import Link from "next/link";



const SingleFooter = ({ classOne, title, data }) => {
  return (
    <div className={classOne}>
      <div className="footer-widget">
        <h3 className="ft-title">{title}</h3>
        <ul className="ft-link">
          {data.map((value, innerIndex) => (
            <li key={innerIndex}>
              <Link href={value.link}>{value.text}</Link>
            </li>
          ))}
        </ul>
      </div>

    </div>
  );
};

export default SingleFooter;
